import {
  Input as Inpt,
  MenuItem,
  Select,
  Snackbar,
  SnackbarContent,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Tooltip,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import {
  ArrowDropDownCircle,
  FilterList,
  TableChart,
  TableRows,
} from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useCallback } from "react";
import { styled } from "@mui/system";
import {
  getDateDDMM,
  getDay,
  LoadingPage,
  MonthFilter,
  Nodata,
} from "../../sdk";
import useForecastSheet from "../hooks/useForecastSheetDaily";
import { useHistory } from "react-router-dom";

import ForecastSheetDailyTableView from "./ForecastSheetDailyTableView";
import { StyledHeaderCell } from "./StyledHeaderCell";

export const TRow = styled(TableRow)`
  &.MuiTableRow-root {
    padding: 10px 0;
    height: 56px;
    &:nth-of-type(odd) {
      background: #f1f2fe;
    }
  }
`;
export const TCell = styled(TableCell)`
  &.MuiTableCell-root {
    font: normal normal normal 14px/28px Roboto;
    letter-spacing: 0px;
    color: #000;
    padding: 0px 0px;
    border: none;
    text-align: ${(props) => (props.isInEditMode ? "left" : "left")};
    text-transform: capitalize;
    white-space: nowrap;
  }
`;
export const Tabhead = styled(TableCell)`
  &.MuiTableCell-root {
    text-align: left;
    font: normal normal bold 14px/23px Roboto;
    letter-spacing: 0px;
    color: #000;
    padding: 0px 0px;
    border: none;
    text-transform: capitalize;
    background: rgba(48, 111, 188, 1);
  }
`;
export const THead = styled(TableHead)`
  &.MuiTableHead-root {
    tr.MuiTableRow-root {
      background: transparent;
      width: 100%;
    }
  }
`;
const DateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 56px;
  border: none;
`;
const Container = styled(Box)`
  padding: 80px 20px 0px 80px;
  width: 100%;
`;
const Header = styled(Box)`
  font: normal normal bold 14px/18px Roboto;
  font-weight: 400;
  padding: 1px 5px;
  height: 20px;
  border-bottom: 0.1px solid #1106411a;
  display: flex;
  min-width: 90px;
  display: flex;
  align-items: center;
  justify-content: start;
  svg.MuiSelect-icon {
    color: white;
  }
`;
const Cell = styled(Box)`
  font: normal normal normal 14px/20px Roboto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  border-bottom: 1.5px solid #1106411a;
  width: 82px;
  text-align: center;
`;

export const AppBar = styled(Box)`
  top: 76px;
  left: 80px;
  height: 52px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  margin-bottom: 20px;
  padding: 0 80px;
  display: flex;
  align-items: center;
`;

export const TableWrapper = styled(Box)`
  height: calc(100vh - 180px);
  margin-bottom: 10px;
  overflow: auto;
  background-color: #ffffff;
`;

export const HorizontalLine = styled(Box)`
  background-color: #110641;
  width: 100%;
`;

export const PickupContainer = styled(Box)`
  display: flex;
  align-items: center;
  outline: 1px solid #1106411a;
`;
export const PickupName = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  white-space: wrap;
  font: normal normal bold 12px/20px Roboto;
`;
export const HeaderContainer = styled(Box)`
  flex: 1;
  outline: 1px solid #1106411a;
`;
const Input = styled(Inpt)`
  input.MuiInputBase-input {
    padding: 0;
    font: 410 16px/20px Roboto;
    letter-spacing: 0px;
    color: #000;
    text-align: center;
    font: normal normal normal 15px/20px Roboto;

    border: none;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &&&.MuiInput-underline::before {
    border-bottom: none;
  }
  &&&.MuiInput-underline::after {
    border-bottom: none;
  }
`;
export const Options = styled(Select)`
  .MuiSelect-select.MuiSelect-select {
    font: normal normal bold 12px/18px Roboto;
    min-width: 180px;
    text-align: center;
    color: white;
  }
`;
export const TextOnlyTooltip = styled(Tooltip)(({ theme }) => ({
  ".tooltip": {
    font: "normal normal normal 12px/16px Roboto",
  },
}));

const TextOnlyTooltipSegment = styled(Tooltip)(({ theme }) => ({
  ".tooltip": {
    color: "#fff",
    font: "normal normal normal 16px/20px Roboto",
    boxShadow: "0px 4px 8px #00000035",
    background: "#110641 0% 0% no-repeat padding-box",
    textAlign: "left",
    marginLeft: "-10px",
    marginTop: "-10px",
  },
  ".arrow": {
    "&:before": {
      border: "1px solid #E6E8ED",
    },
    color: "#110641",
  },
}));

const StyledContainer = styled(Container)(() => ({
  ".sticky": {
    position: "sticky",
    left: 0,
    background: "#f1f2fe",
    zIndex: "8",
  },
  ".stickyRight": {
    position: "sticky",
    left: "53.5px",
    background: "#f1f2fe",
    zIndex: "8",
  },
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  height: theme.spacing(5),
  boxShadow: "0px 4px 4px rgba(3, 4, 94, 0.2)",
  borderRadius: "8px",
}));

export const ForecastSheetDaily = ({ setPageHeader }) => {
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);

  const {
    forecastSheetData,
    comparitiveDate,
    setComparitiveDate,
    handleActualChange,
    handleRevenueChange,
    showPickupRequireToAchieve,
    handleShowPickupRequiredRow,
    postForecastData,
    Loading,
    dates,
    setOpen,
    networkMsg,
    open,
    handleFilterDialogBox,
    filterDialogBox,
    handleFilter,
    filterArray,
    filterAll,
  } = useForecastSheet();

  const shouldRender = useCallback(
    (filterIndex) => filterAll === true || filterArray[filterIndex] === true,
    [filterAll, filterArray],
  );

  useEffect(() => {
    setPageHeader("Forecast Daily");
    return () => {
      setPageHeader("");
    };
  }, [setPageHeader]);

  const handleChangeView = (mode) => {
    searchParams.set("view", mode);
    history.replace({
      pathname: history.location.pathname,
      search: searchParams.toString(),
    });
  };

  const SingleSegmentView = useMemo(() => {
    const view = searchParams.get("view");
    return view === "single-segment";
  }, [searchParams]);

  if (Loading) return <LoadingPage />;

  return (
    <>
      {SingleSegmentView ? (
        <ForecastSheetDailyTableView
          jsonData={forecastSheetData}
          comparitiveDate={comparitiveDate}
          setComparitiveDate={setComparitiveDate}
        />
      ) : (
        <StyledContainer>
          <Stack direction={"row"} justifyContent="space-between">
            <Stack direction={"row"} spacing={2}>
              <MonthFilter
                value={comparitiveDate}
                onChange={setComparitiveDate}
              />
              <Paper
                elevation={1}
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  id="account-menu"
                  onClick={() => {
                    handleFilterDialogBox();
                  }}
                >
                  <Stack direction={"row"} spacing={2}>
                    <FilterList />
                    <Typography>Filters</Typography>
                  </Stack>
                </Button>
                <Menu
                  id="account-menu"
                  open={filterDialogBox}
                  onClose={handleFilterDialogBox}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "left", vertical: "top" }}
                  style={{
                    left: "300px",
                    top: "100px",
                  }}
                >
                  <MenuItem>
                    <FormGroup>
                      <Stack
                        direction={"Column"}
                        spacing={2}
                        justifyContent="center"
                        alignItems="start"
                      >
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Last Year"
                          style={{ marginLeft: "0" }}
                          name="Last Year"
                          checked={filterArray[0]}
                          onChange={(e) => {
                            handleFilter(e.target.checked, e.target.name);
                          }}
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Budget"
                          name="Budget"
                          checked={filterArray[1]}
                          onChange={(e) => {
                            handleFilter(e.target.checked, e.target.name);
                          }}
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Locked Forecast"
                          name="Locked Forecast"
                          checked={filterArray[2]}
                          onChange={(e) => {
                            handleFilter(e.target.checked, e.target.name);
                          }}
                        />

                        <FormControlLabel
                          control={<Checkbox />}
                          label="BOB"
                          name="BOB"
                          checked={filterArray[3]}
                          onChange={(e) => {
                            handleFilter(e.target.checked, e.target.name);
                          }}
                        />
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Actual/Forecast"
                          name="Actual"
                          checked={filterArray[4]}
                          onChange={(e) => {
                            handleFilter(e.target.checked, e.target.name);
                          }}
                        />
                      </Stack>
                    </FormGroup>
                  </MenuItem>
                </Menu>
              </Paper>
              <Button
                label="All"
                onClick={() => {
                  handleFilter(true, "All");
                }}
                size="small"
                style={{
                  width: "100px",
                  height: "45px",
                  background: filterAll ? "rgb(48,111,188)" : "#fff",
                  color: filterAll ? "#fff" : "rgb(48,111,188)",
                  font: "normal normal bold 14px/15px Roboto",
                  fontWeight: "600",
                  marginBottom: "16px",
                }}
              >
                All
              </Button>
            </Stack>

            <Stack flexDirection="row" gap="18px" alignItems={"center"}>
              <StyledToggleButtonGroup value={"all"} exclusive color="primary">
                <ToggleButton value="all">
                  <TableRows />
                </ToggleButton>
                <ToggleButton
                  value="single-segment"
                  onClick={() => handleChangeView("single-segment")}
                >
                  <TableChart />
                </ToggleButton>
              </StyledToggleButtonGroup>

              <Button
                type="submit"
                style={{
                  height: "45px",
                  backgroundColor: "rgb(48,111,188)",
                  font: "normal normal bold 14px/15px Roboto",
                  color: "white",
                }}
                onClick={postForecastData}
              >
                Save
              </Button>
            </Stack>
          </Stack>

          {!forecastSheetData || forecastSheetData.length === 0 ? (
            <Nodata />
          ) : (
            <TableWrapper>
              <Table stickyHeader>
                <THead>
                  <TRow>
                    <Tabhead
                      style={{
                        padding: "4px 8px",
                        zIndex: "10",
                        visibility: forecastSheetData ? "visible" : "hidden",
                        background: "rgba(48, 111, 188, 1)",
                        color: "#ffffff",
                        borderRight: "1.5px solid rgba(48, 111, 188, 1)",
                      }}
                      rowSpan={2}
                      className="sticky"
                    >
                      Items
                    </Tabhead>
                    <Tabhead
                      style={{
                        padding: "4px 8px",
                        zIndex: "10",
                        visibility: forecastSheetData ? "visible" : "hidden",
                        textAlign: "center",
                        background: "rgba(48, 111, 188, 1)",
                        color: "#ffffff",
                      }}
                      rowSpan={2}
                      className="stickyRight"
                    >
                      KPI
                      <br /> (Key Performance Indicators)
                    </Tabhead>

                    {dates?.map((date, index) => {
                      return (
                        <Tabhead key={index}>
                          <DateContainer>
                            <TCell
                              style={{
                                font: "normal normal 14px/28px Roboto",
                                textAlign: "center",
                                width: "80px",
                                border: "none",
                                background: "rgba(48, 111, 188, 1)",
                                color: "#ffffff",
                              }}
                            >
                              {getDateDDMM(date)}
                              <br />
                              {getDay(date)}
                            </TCell>
                          </DateContainer>
                        </Tabhead>
                      );
                    })}
                    {forecastSheetData && (
                      <Tabhead
                        style={{
                          textAlign: "center",
                          color: "#ffffff",
                        }}
                      >
                        Total
                      </Tabhead>
                    )}
                  </TRow>
                </THead>
                <TableBody>
                  {forecastSheetData?.map((item, segmentIndex) => {
                    return (
                      <React.Fragment key={segmentIndex}>
                        <TRow key={segmentIndex}>
                          <TextOnlyTooltipSegment
                            disableFocusListener
                            disableTouchListener
                            title={item.description ? item.description : ""}
                            placement="right"
                            arrow
                            style={{ cursor: "default" }}
                          >
                            <TCell
                              style={{
                                padding: "0 10px",
                                font: "normal normal bold 14px/23px Roboto",
                                background:
                                  item.systemName !== "Total"
                                    ? "#fff"
                                    : "#306fbc",
                                color:
                                  item.systemName !== "Total" ? "#000" : "#fff",
                              }}
                              className="sticky"
                            >
                              <p
                                style={{
                                  writingMode: "tb-rl",
                                  transform: "rotate(-180deg)",
                                  margin: "auto",
                                  cursor: "default",
                                }}
                              >
                                {item.systemName}
                              </p>
                            </TCell>
                          </TextOnlyTooltipSegment>
                          <TCell className="stickyRight">
                            {shouldRender(0) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Nights LY
                              </StyledHeaderCell>
                            )}

                            {shouldRender(1) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Nights Budget
                              </StyledHeaderCell>
                            )}

                            {shouldRender(2) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Nights Locked Forecast
                              </StyledHeaderCell>
                            )}

                            {shouldRender(3) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Nights BOB
                              </StyledHeaderCell>
                            )}

                            {shouldRender(4) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Nights Actual / Forecast{" "}
                              </StyledHeaderCell>
                            )}
                            {/* 
                            {item.systemName !== "Total" && (
                              <Header
                                style={{
                                  background:
                                    "rgba(48, 111, 188, 1) 0% 0% no-repeat padding-box",
                                  color: "white",
                                  height: "30px",
                                  borderRight: "1.5px solid #1106411a",
                                  borderLeft: "1.5px solid #1106411a",
                                  borderBottom: "1.5px solid #1106411a",
                                }}
                              >
                                <Options
                                  disableUnderline
                                  defaultValue={0}
                                  variant="standard"
                                  value={
                                    (selectedPickup[segmentIndex] &&
                                      selectedPickup[segmentIndex][0]) ??
                                    1
                                  }
                                  onChange={(e) =>
                                    setPickup(segmentIndex, 0, e.target.value)
                                  }
                                  style={{
                                    fontFamily: "Roboto",
                                    marginLeft: "63px",
                                  }}
                                >
                                  {typesOfPickup.map((pickup, index) => (
                                    <MenuItem
                                      style={{
                                        fontFamily: "Roboto",
                                        height: "30px",
                                      }}
                                      value={pickup.value}
                                      key={index}
                                    >
                                      {pickup.name}
                                    </MenuItem>
                                  ))}
                                </Options>
                              </Header>
                            )} */}

                            {shouldRender(0) && (
                              <StyledHeaderCell
                                systemName={item.systemName}
                                variant="adr"
                              >
                                ADR LY
                              </StyledHeaderCell>
                            )}

                            {shouldRender(1) && (
                              <StyledHeaderCell
                                systemName={item.systemName}
                                variant="adr"
                              >
                                ADR Budget
                              </StyledHeaderCell>
                            )}

                            {shouldRender(2) && (
                              <StyledHeaderCell
                                systemName={item.systemName}
                                variant="adr"
                              >
                                ADR Locked Forecast
                              </StyledHeaderCell>
                            )}

                            {shouldRender(3) && (
                              <StyledHeaderCell
                                systemName={item.systemName}
                                variant="adr"
                              >
                                ADR BOBs
                              </StyledHeaderCell>
                            )}

                            {shouldRender(4) && (
                              <StyledHeaderCell
                                systemName={item.systemName}
                                variant="adr"
                              >
                                ADR Actual / Forecast
                              </StyledHeaderCell>
                            )}

                            {/* {item.systemName !== "Total" && (
                              <Header
                                style={{
                                  background:
                                    "rgba(48, 111, 188, 1) 0% 0% no-repeat padding-box",
                                  color: "white",
                                  height: "30px",
                                  borderRight: "1.5px solid #1106411a",
                                  borderLeft: "1.5px solid #1106411a",
                                  borderBottom: "1.5px solid #1106411a",
                                }}
                              >
                                <Options
                                  disableUnderline
                                  defaultValue={0}
                                  variant="standard"
                                  value={
                                    (selectedPickup[segmentIndex] &&
                                      selectedPickup[segmentIndex][1]) ??
                                    1
                                  }
                                  onChange={(e) =>
                                    setPickup(segmentIndex, 1, e.target.value)
                                  }
                                  style={{
                                    fontFamily: "Roboto",
                                    marginLeft: "63px",
                                  }}
                                >
                                  {typesOfPickup.map((pickup, index) => (
                                    <MenuItem
                                      style={{
                                        fontFamily: "Roboto",
                                        height: "30px",
                                      }}
                                      value={pickup.value}
                                      key={index}
                                    >
                                      {pickup.name}
                                    </MenuItem>
                                  ))}
                                </Options>
                              </Header>
                            )} */}

                            {shouldRender(0) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Revenue LY
                              </StyledHeaderCell>
                            )}
                            {shouldRender(1) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Revenue Budget
                              </StyledHeaderCell>
                            )}

                            {shouldRender(2) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Revenue Locked Forecast
                              </StyledHeaderCell>
                            )}

                            {shouldRender(3) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Revenue BOB
                              </StyledHeaderCell>
                            )}

                            {shouldRender(4) && (
                              <StyledHeaderCell systemName={item.systemName}>
                                Room Revenue Actual / Forecast
                              </StyledHeaderCell>
                            )}

                            {/* {item.systemName !== "Total" && (
                              <Header
                                style={{
                                  background:
                                    "rgba(48, 111, 188, 1) 0% 0% no-repeat padding-box",
                                  color: "white",
                                  height: "30px",
                                  borderRight: "1.5px solid #1106411a",
                                  borderLeft: "1.5px solid #1106411a",
                                  borderBottom: "1.5px solid #1106411a",
                                }}
                              >
                                <Options
                                  disableUnderline
                                  defaultValue={0}
                                  variant="standard"
                                  value={
                                    (selectedPickup[segmentIndex] &&
                                      selectedPickup[segmentIndex][2]) ??
                                    1
                                  }
                                  onChange={(e) =>
                                    setPickup(segmentIndex, 2, e.target.value)
                                  }
                                  style={{
                                    fontFamily: "Roboto",
                                    marginLeft: "63px",
                                  }}
                                >
                                  {typesOfPickup.map((pickup, index) => (
                                    <MenuItem
                                      style={{ fontFamily: "Roboto" }}
                                      value={pickup.value}
                                      key={index}
                                    >
                                      {pickup.name}
                                    </MenuItem>
                                  ))}
                                </Options>
                              </Header>
                            )} */}
                          </TCell>
                          {item.budgetModel.map((budget, index) => {
                            return (
                              <TCell
                                key={index}
                                style={{
                                  background:
                                    item.systemName !== "Total"
                                      ? "#fff"
                                      : "#306fbc",
                                  color:
                                    item.systemName !== "Total"
                                      ? "#000"
                                      : "#fff",
                                  borderLeft: "1px solid #e7e6ec",
                                }}
                              >
                                {shouldRender(0) && (
                                  <TransFormInt
                                    data={budget.roomsLY}
                                    style={{
                                      background: "#fff",
                                      height: "30px",
                                      width: "82px",
                                    }}
                                  />
                                )}

                                {/* adding input field in Room Night Budget. */}

                                {shouldRender(1) &&
                                  (item?.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "#fff",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <Input
                                        value={
                                          budget.roomsBudget
                                            ? budget.roomsBudget
                                            : ""
                                        }
                                        min="0"
                                        type="number"
                                        onChange={(e) => {
                                          if (e.target.value >= 0) {
                                            handleRevenueChange(
                                              index,
                                              segmentIndex,
                                              "roomsBudget",
                                              parseInt(e.target.value),
                                            );
                                          }
                                        }}
                                        style={{ fontSize: "14px" }}
                                      />
                                    </Cell>
                                  ) : (
                                    <TransFormInt
                                      style={{ background: "#fff" }}
                                      data={budget?.roomsBudget}
                                    />
                                  ))}

                                {shouldRender(2) && (
                                  <TransFormInt data={budget.roomsLocked} />
                                )}

                                {shouldRender(3) && (
                                  <TransFormInt data={budget.roomsOTB} />
                                )}

                                {shouldRender(4) &&
                                  (item.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "#fff",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          budget.roomsActual
                                            ? budget.roomsActual
                                            : ""
                                        }
                                        min="0"
                                        type="number"
                                        onChange={(e) => {
                                          if (e.target.value >= 0) {
                                            handleActualChange(
                                              index,
                                              segmentIndex,
                                              "roomsActual",
                                              parseInt(e.target.value),
                                            );
                                          }
                                        }}
                                        style={{ fontSize: "14px" }}
                                      />
                                    </Cell>
                                  ) : (
                                    <TransFormInt
                                      style={{ background: "#fff" }}
                                      data={budget.roomsActual}
                                    />
                                  ))}

                                {/* {item.systemName !== "Total" && (
                                  <Cell style={{ background: "#fff" }}>{}</Cell>
                                )} */}

                                {shouldRender(0) && (
                                  <TransForm
                                    style={{
                                      background: "rgba(48,111,188,0.2)",
                                    }}
                                    data={budget.arrLY}
                                  />
                                )}

                                {filterAll === true ? (
                                  item.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                        fontWeight: "bold",
                                        borderRight:
                                          "solid 1px rgb(231,230,236)",
                                      }}
                                    >
                                      {
                                        <Input
                                          value={
                                            budget.arrBudget
                                              ? budget.arrBudget
                                              : ""
                                          }
                                          type="number"
                                          onChange={(e) => {
                                            handleRevenueChange(
                                              index,
                                              segmentIndex,
                                              "arrBudget",
                                              parseInt(e.target.value),
                                            );
                                          }}
                                        />
                                      }
                                    </Cell>
                                  ) : (
                                    <TransForm
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                      }}
                                      data={budget.arrBudget}
                                    />
                                  )
                                ) : (
                                  filterArray[1] === true &&
                                  (item.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                        fontWeight: "bold",
                                        borderRight:
                                          "solid 1px rgb(231,230,236)",
                                      }}
                                    >
                                      {
                                        <Input
                                          value={
                                            budget.arrBudget
                                              ? budget.arrBudget
                                              : ""
                                          }
                                          type="number"
                                          onChange={(e) => {
                                            handleRevenueChange(
                                              index,
                                              segmentIndex,
                                              "arrBudget",
                                              parseInt(e.target.value),
                                            );
                                          }}
                                        />
                                      }
                                    </Cell>
                                  ) : (
                                    <TransForm
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                      }}
                                      data={budget.arrBudget}
                                    />
                                  ))
                                )}

                                {shouldRender(2) && (
                                  <TransForm
                                    style={{
                                      background: "rgba(48,111,188,0.2)",
                                    }}
                                    data={budget.arrLocked}
                                  />
                                )}

                                {shouldRender(3) && (
                                  <TransForm
                                    style={{
                                      background: "rgba(48,111,188,0.2)",
                                    }}
                                    data={
                                      budget.roomsOTB
                                        ? budget.revenueOTB / budget.roomsOTB
                                        : 0
                                    }
                                  />
                                )}

                                {filterAll === true ? (
                                  item.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                        fontWeight: "bold",
                                        borderRight:
                                          "solid 1px rgb(231,230,236)",
                                      }}
                                    >
                                      {
                                        <Input
                                          defaultValue={
                                            budget.arrActual
                                              ? budget.arrActual
                                              : ""
                                          }
                                          type="number"
                                          onChange={(e) =>
                                            handleActualChange(
                                              index,
                                              segmentIndex,
                                              "arrActual",
                                              parseInt(e.target.value),
                                            )
                                          }
                                        />
                                      }
                                    </Cell>
                                  ) : (
                                    <TransForm
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                      }}
                                      data={(budget.arrActual)}
                                    />
                                  )
                                ) : (
                                  filterArray[4] === true &&
                                  (item.systemName !== "Total" ? (
                                    <Cell
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                        fontWeight: "bold",
                                        borderRight:
                                          "solid 1px rgb(231,230,236)",
                                      }}
                                    >
                                      {
                                        <Input
                                          defaultValue={
                                            budget.arrActual
                                              ? budget.arrActual
                                              : ""
                                          }
                                          type="number"
                                          onChange={(e) =>
                                            handleActualChange(
                                              index,
                                              segmentIndex,
                                              "arrActual",
                                              parseInt(e.target.value),
                                            )
                                          }
                                        />
                                      }
                                    </Cell>
                                  ) : (
                                    <TransForm
                                      style={{
                                        background: "rgba(48,111,188,0.2)",
                                      }}
                                      data={
                                        budget.arrActual
                                      }
                                    />
                                  ))
                                )}

                                {/* {item.systemName !== "Total" && (
                                  <Cell style={{ background: "#fff" }}>
                                    {""}
                                  </Cell>
                                )} */}

                                {shouldRender(0) && (
                                  <TransFormInt
                                    data={budget.revenueLY}
                                    isRounded
                                  />
                                )}

                                {shouldRender(1) && (
                                  <TransFormInt
                                    data={budget.revenueBudget}
                                    isRounded
                                  />
                                )}

                                {shouldRender(2) && (
                                  <TransFormInt
                                    data={budget.revenueLocked}
                                    isRounded
                                  />
                                )}

                                {shouldRender(3) && (
                                  <TransFormInt data={budget.revenueOTB} />
                                )}

                                {filterAll === true ? (
                                  item.systemName !== "Total" ? (
                                    <Cell>
                                      {budget.roomsActual && budget.arrActual
                                        ? Math.round(
                                            budget.roomsActual *
                                              budget.arrActual,
                                          )
                                        : budget.revenueActual !== -1
                                        ? Math.round(budget.revenueActual)
                                        : "-"}
                                    </Cell>
                                  ) : (
                                    <TransFormInt
                                      isRounded
                                      data={forecastSheetData
                                        .filter(
                                          (item) => item.systemName !== "Total",
                                        )
                                        .reduce((acc, item) => {
                                          const {
                                            roomsActual,
                                            arrActual,
                                          } = item.budgetModel[index];

                                          if (
                                            roomsActual &&
                                            arrActual &&
                                            roomsActual !== -1 &&
                                            arrActual !== -1
                                          ) {
                                            acc += roomsActual * arrActual;
                                          }

                                          return acc;
                                        }, 0)}
                                    />
                                  )
                                ) : (
                                  filterArray[4] === true &&
                                  (item.systemName !== "Total" ? (
                                    <Cell>
                                      {budget.roomsActual && budget.arrActual
                                        ? Math.round(
                                            budget.roomsActual *
                                              budget.arrActual,
                                          )
                                        : budget.revenueActual !== -1
                                        ? Math.round(budget.revenueActual)
                                        : "-"}
                                    </Cell>
                                  ) : (
                                    <TransFormInt
                                      isRounded
                                      data={forecastSheetData
                                        .filter(
                                          (item) => item.systemName !== "Total",
                                        )
                                        .reduce((acc, item) => {
                                          const {
                                            roomsActual,
                                            arrActual,
                                          } = item.budgetModel[index];

                                          if (
                                            roomsActual &&
                                            arrActual &&
                                            roomsActual !== -1 &&
                                            arrActual !== -1
                                          ) {
                                            acc += roomsActual * arrActual;
                                          }

                                          return acc;
                                        }, 0)}
                                    />
                                  ))
                                )}

                                {/* {item.systemName !== "Total" && (
                                  <Cell style={{ background: "#fff" }}>{}</Cell>
                                )} */}
                              </TCell>
                            );
                          })}
                        </TRow>
                        {item.systemName !== "Total" && (
                          <TRow
                            style={{
                              background: "rgba(48, 111, 188, 1)",
                              height: "8px",
                            }}
                          >
                            <TCell
                              style={{
                                zIndex: "9",
                                background: "rgba(48, 111, 188, 1)",
                              }}
                              className="sticky"
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative",
                                  background: "white",
                                }}
                              >
                                <ArrowDropDownCircle
                                  style={{
                                    fontSize: "22px",
                                    position: "absolute",
                                    cursor: "pointer",
                                    background: "white",
                                    color: "rgba(48, 111, 188, 1)",
                                    left: "0",
                                    zIndex: "1",
                                    transform: showPickupRequireToAchieve[
                                      segmentIndex
                                    ]
                                      ? "rotate(180deg)"
                                      : "none",
                                  }}
                                  onClick={() =>
                                    handleShowPickupRequiredRow(segmentIndex)
                                  }
                                />
                              </span>
                            </TCell>
                            <TCell
                              style={{ background: "rgba(48, 111, 188, 1)" }}
                              colSpan="100%"
                            ></TCell>
                          </TRow>
                        )}
                        {showPickupRequireToAchieve[segmentIndex] && (
                          <>
                            <TRow
                              key={segmentIndex}
                              style={{
                                background: "white",
                              }}
                            >
                              <TCell
                                style={{
                                  padding: "0 10px",
                                  font: "normal normal bold 14px/23px Roboto",
                                  background: "#ffffff",
                                }}
                                className="sticky"
                              >
                                <p
                                  style={{
                                    writingMode: "tb-rl",
                                    transform: "rotate(-180deg)",
                                    margin: "auto",
                                  }}
                                >
                                  Pick up Required to Achieve
                                </p>
                              </TCell>
                              <TCell
                                className="stickyRight"
                                style={{
                                  background: "rgba(241, 246, 252, 1)",
                                }}
                              >
                                <PickupContainer
                                  style={{ display: "flex", height: "108px" }}
                                >
                                  <PickupName>LY</PickupName>
                                  <HeaderContainer style={{ height: "108px" }}>
                                    <Header style={{ height: "36px" }}>
                                      Room Nights
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      ADR
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      Room Revenue
                                    </Header>
                                  </HeaderContainer>
                                </PickupContainer>
                                <PickupContainer
                                  style={{ display: "flex", height: "108px" }}
                                >
                                  <PickupName style={{ height: "108px" }}>
                                    Budget
                                  </PickupName>
                                  <HeaderContainer>
                                    <Header style={{ height: "36px" }}>
                                      Room Nights
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      ADR
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      Room Revenue
                                    </Header>
                                  </HeaderContainer>
                                </PickupContainer>
                                <PickupContainer
                                  style={{ display: "flex", height: "108px" }}
                                >
                                  <PickupName style={{ height: "108px" }}>
                                    Locked <br /> Forecast
                                  </PickupName>
                                  <HeaderContainer>
                                    <Header style={{ height: "36px" }}>
                                      Room Nights
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      ADR
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      Room Revenue
                                    </Header>
                                  </HeaderContainer>
                                </PickupContainer>
                                <PickupContainer
                                  style={{ display: "flex", height: "108px" }}
                                >
                                  <PickupName style={{ height: "108px" }}>
                                    Current <br /> Forecast
                                  </PickupName>
                                  <HeaderContainer>
                                    <Header style={{ height: "36px" }}>
                                      Room Nights
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      ADR
                                    </Header>
                                    <Header style={{ height: "36px" }}>
                                      Room Revenue
                                    </Header>
                                  </HeaderContainer>
                                </PickupContainer>
                              </TCell>
                              {item.budgetModel.map((budget, index) => {
                                return (
                                  <TCell
                                    key={index}
                                    style={{
                                      borderLeft: "1px solid #e7e6ec",
                                    }}
                                  >
                                    <TransFormPickup
                                      data={budget.roomsLY - budget.roomsOTB}
                                    />
                                    <TransFormPickup
                                      data={
                                        (budget.revenueLY - budget.revenueOTB) /
                                        (budget.roomsLY - budget.roomsOTB)
                                      }
                                    />
                                    <TransFormPickup
                                      data={
                                        budget.revenueLY - budget.revenueOTB
                                      }
                                    />

                                    <TransFormPickup
                                      data={
                                        budget.roomsBudget - budget.roomsOTB
                                      }
                                    />
                                    <TransFormPickup
                                      data={
                                        (budget.revenueBudget -
                                          budget.revenueOTB) /
                                        (budget.roomsBudget - budget.roomsOTB)
                                      }
                                    />
                                    <TransFormPickup
                                      data={
                                        budget.revenueBudget - budget.revenueOTB
                                      }
                                    />

                                    <TransFormPickup
                                      data={
                                        budget.roomsLocked - budget.roomsOTB
                                      }
                                    />
                                    <TransFormPickup
                                      data={budget.revenueBudget}
                                    />
                                    <TransFormPickup
                                      data={
                                        budget.revenueLocked - budget.revenueOTB
                                      }
                                    />

                                    <TransFormPickup
                                      data={
                                        budget.roomsActual - budget.roomsOTB
                                      }
                                    />
                                    <TransFormPickup
                                      data={
                                        (budget.revenueActual -
                                          budget.revenueOTB) /
                                        (budget.roomsActual - budget.roomsOTB)
                                      }
                                    />
                                    <TransFormPickup
                                      data={
                                        budget.revenueActual - budget.revenueOTB
                                      }
                                    />
                                  </TCell>
                                );
                              })}
                            </TRow>
                            <TRow
                              style={{
                                background: "rgba(48, 111, 188, 1)",
                                height: "8px",
                              }}
                            >
                              <td colSpan="100%"></td>
                            </TRow>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableWrapper>
          )}

          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={!!open}
            autoHideDuration={3000}
            onClose={() => setOpen(null)}
          >
            {
              <SnackbarContent
                style={{
                  backgroundColor: open === "success" ? "#228b22" : "#CA3433",
                }}
                message={networkMsg}
              />
            }
          </Snackbar>
        </StyledContainer>
      )}
    </>
  );
};

function TransForm({ data, style }) {
  if (isNaN(data)) {
    return <Cell style={style}>-</Cell>;
  }
  return <Cell style={style}>{parseFloat(data).toFixed(2)}</Cell>;
}

function TransFormInt({ data, isRounded = false }) {
  if (isNaN(data)) {
    return <Cell>-</Cell>;
  }
  return <Cell>{isRounded ? Math.round(data) : parseInt(data)}</Cell>;
}

function TransFormPickup({ data }) {
  if (isNaN(data) || data === Infinity || data === -Infinity) {
    return <Cell>-</Cell>;
  }
  const textColor = data < 0 ? "red" : "green";
  return <Cell style={{ color: textColor }}>{parseInt(data)}</Cell>;
}
